module.exports = __webpack_public_path__ + "img/edit-map-on.aab258df.png";